import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
  Badge,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import {
  Search, 
} from "@mui/icons-material"; 
import { ContactResponseDto } from "../../../common/auth/types/authTypes";
import { getContactList } from "../../../common/auth/service/contactApi";
import "./OverallLayout.css";

function ContactInformation() {
  const [contacts, setContacts] = useState<ContactResponseDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const itemPerpage = 15;

  const [selectedContact, setSelectedContact] =
    useState<ContactResponseDto | null>(null);

  const [openModal, setOpenModal] = useState(false);

  const loadContacts = async () => {
    try {
      setLoading(true);

      const response = await getContactList();

      setContacts(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadContacts();
  }, []);

  const filteredContacts = useMemo(() => {
    return contacts.filter((item) => {
      const value = search.toLowerCase();

      return (
        item.name.toLowerCase().includes(value) ||
        item.email.toLowerCase().includes(value) ||
        item.phone?.toLowerCase().includes(value) ||
        item.subject.toLowerCase().includes(value)
      );
    });
  }, [contacts, search]);

  const todaysMessages = contacts.filter((x) => {
    const today = new Date().toDateString();
    return new Date(x.createdAt).toDateString() === today;
  }).length;


   const totalPages = Math.ceil(filteredContacts.length / itemPerpage)

   const startIndex = (currentPage -1)* itemPerpage;
   const endIndex = startIndex + itemPerpage;

   const paginatedContacts = filteredContacts.slice(
    startIndex,
    endIndex
   );

  return (
    <Container fluid className="py-4">
      {/* Header */}

       

      {/* Statistics */}

   

      {/* Search */}

      <Card
        style={{
          borderRadius: 18,
          border: "none",
          marginBottom: 20,
          boxShadow:
            "0 8px 20px rgba(0,0,0,.08)",
        }}
      >
        <CardBody>
          <Row>
            <Col lg="5">
              <InputGroup className="search-group">
  <InputGroupText>
    <Search />
  </InputGroupText>

  <Input className="Search-input"
    placeholder="Search by name, email, phone or subject..."
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setCurrentPage(1);
    }}
  />
</InputGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

   {/* Desktop Table */}

<div className="d-none d-md-block">
  <Card
    style={{
      borderRadius: 18,
      border: "none",
      boxShadow: "0 8px 20px rgba(0,0,0,.08)",
    }}
  >
    <CardBody style={{ padding: 0 }}>
      <Table hover responsive className="mb-0 align-middle">
        <thead
          style={{
            background:
              "linear-gradient(to right,#1e3a8a,#2563eb)",
            color: "#fff",
          }}
        >
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Subject</th>
            <th>Message</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={8} className="text-center py-5">
                <Spinner />
              </td>
            </tr>
          ) : filteredContacts.length === 0 ? (
            <tr>
              <td colSpan={8} className="text-center py-5">
                No Contact Requests Found
              </td>
            </tr>
          ) : (
            paginatedContacts.map((item, index) => (
              <tr key={item.id}>
                <td>{startIndex + index + 1}</td>

                <td>{item.name}</td>

                <td>{item.email}</td>

                <td>{item.phone || "-"}</td>

                <td>{item.subject}</td>

                <td
                  style={{
                    maxWidth: 250,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {item.message}
                </td>

                <td>
                  {new Date(item.createdAt).toLocaleDateString()}
                </td>

                <td>
                  <Button
                    size="sm"
                    color="primary"
                    onClick={() => {
                      setSelectedContact(item);
                      setOpenModal(true);
                    }}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </CardBody>
  </Card>
</div>

{/* Mobile Cards */}

<div className="d-block d-md-none">
  {loading ? (
    <div className="text-center py-5">
      <Spinner />
    </div>
  ) : filteredContacts.length === 0 ? (
    <Card>
      <CardBody className="text-center">
        No Contact Requests Found
      </CardBody>
    </Card>
  ) : (
    paginatedContacts.map((item) => (
      <Card
        key={item.id}
        className="mb-3 border-0"
        style={{
          borderRadius: 18,
          boxShadow: "0 8px 20px rgba(0,0,0,.08)",
        }}
      >
        <CardBody>

          <div className="d-flex justify-content-between mb-3">
            <h5
              className="mb-0"
              style={{
                color: "#2563eb",
                fontWeight: 600,
              }}
            >
              {item.name}
            </h5>

            <Badge color="primary">
              Contact
            </Badge>
          </div>

          <p className="mb-2">
            <strong>Email</strong>
            <br />
            {item.email}
          </p>

          <p className="mb-2">
            <strong>Phone</strong>
            <br />
            {item.phone || "-"}
          </p>

          <p className="mb-2">
            <strong>Subject</strong>
            <br />
            {item.subject}
          </p>

          <p
            className="text-muted"
            style={{
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {item.message}
          </p>

          <div className="d-flex justify-content-between align-items-center mt-3">

            <small className="text-muted">
              {new Date(item.createdAt).toLocaleDateString()}
            </small>

            <Button
              size="sm"
              color="primary"
              onClick={() => {
                setSelectedContact(item);
                setOpenModal(true);
              }}
            >
              View Details
            </Button>

          </div>

        </CardBody>



      </Card>
    ))
  )}


</div>

<div className="d-flex justify-content-between align-items-center mt-4 flex-wrap">

  <div>
    Showing {startIndex + 1} - {Math.min(endIndex, filteredContacts.length)} of {filteredContacts.length}
  </div>

  <Pagination>

    <PaginationItem disabled={currentPage === 1}>
      <PaginationLink
        previous
        className="bg-primary text-white border-primary"
        onClick={(e) => {
          e.preventDefault();
          setCurrentPage((prev) => prev - 1);
        }}
      />
    </PaginationItem>

    

    <PaginationItem disabled={currentPage === totalPages}>
      <PaginationLink
        next
        className="bg-primary text-white border-primary"
        onClick={(e) => {
          e.preventDefault();
          setCurrentPage((prev) => prev + 1);
        }}
      />
    </PaginationItem>

  </Pagination>

</div>

      {/* View Modal */}

      <Modal
  isOpen={openModal}
  toggle={() => setOpenModal(false)}
  centered
  size="lg"
>
  <ModalHeader
    toggle={() => setOpenModal(false)}
    style={{
      background: "linear-gradient(135deg,#2563eb,#4f46e5)",
      color: "#fff",
      borderBottom: "none",
      padding: "18px 25px",
    }}
  >
    📩 Contact Details
  </ModalHeader>

  <ModalBody
    style={{
      background: "#f8fafc",
      padding: "25px",
    }}
  >
    {selectedContact && (
      <>
        <Row className="g-3">

          <Col md={6}>
            <Card
              className="h-100"
              style={{
                border: "none",
                borderRadius: "15px",
                boxShadow: "0 4px 15px rgba(0,0,0,.08)",
              }}
            >
              <CardBody>
                <small className="text-muted">Name</small>

                <h5
                  style={{
                    color: "#2563eb",
                    fontWeight: 700,
                    marginTop: 5,
                  }}
                >
                  {selectedContact.name}
                </h5>
              </CardBody>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="h-100"
              style={{
                border: "none",
                borderRadius: "15px",
                boxShadow: "0 4px 15px rgba(0,0,0,.08)",
              }}
            >
              <CardBody>
                <small className="text-muted">
                  Email
                </small>

                <h6
                  style={{
                    marginTop: 5,
                    wordBreak: "break-word",
                  }}
                >
                  {selectedContact.email}
                </h6>
              </CardBody>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="h-100"
              style={{
                border: "none",
                borderRadius: "15px",
                boxShadow: "0 4px 15px rgba(0,0,0,.08)",
              }}
            >
              <CardBody>
                <small className="text-muted">
                  Phone Number
                </small>

                <h6 style={{ marginTop: 5 }}>
                  {selectedContact.phone || "-"}
                </h6>
              </CardBody>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="h-100"
              style={{
                border: "none",
                borderRadius: "15px",
                boxShadow: "0 4px 15px rgba(0,0,0,.08)",
              }}
            >
              <CardBody>
                <small className="text-muted">
                  Subject 
                </small>

                 <h6 style={{ marginTop: 5 }}>
                  {selectedContact.subject || "-"}
                </h6>
              </CardBody>
            </Card>
          </Col>

        </Row>

        <Card
          className="mt-4"
          style={{
            border: "none",
            borderRadius: "18px",
            boxShadow: "0 4px 15px rgba(0,0,0,.08)",
          }}
        >
          <CardBody>

            <h5
              style={{
                color: "#2563eb",
                fontWeight: 700,
                marginBottom: 15,
              }}
            >
              💬 Message
            </h5>

            <div
              style={{
                background: "#f8fafc",
                padding: "18px",
                borderRadius: "12px",
                lineHeight: "1.8",
                border: "1px solid #e5e7eb",
                whiteSpace: "pre-wrap",
              }}
            >
              {selectedContact.message}
            </div>

          </CardBody>
        </Card>

        <Card
          className="mt-4"
          style={{
            border: "none",
            borderRadius: "15px",
            background: "#eef4ff",
          }}
        >
          <CardBody className="d-flex justify-content-between align-items-center flex-wrap">

            <div>
              <small className="text-muted">
                Received On
              </small>

              <h6
                style={{
                  marginTop: 5,
                  fontWeight: 600,
                }}
              >
                {new Date(
                  selectedContact.createdAt
                ).toLocaleString()}
              </h6>
            </div>

            <Button
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              Close
            </Button>

          </CardBody>
        </Card>
      </>
    )}
  </ModalBody>
</Modal>
    </Container>
  );
}

export default ContactInformation;